<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0"></h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>

      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-6 col-md-6">
          <stats-card
            title="Leads Last 30 days"
            type="gradient-blue"
            :sub-title="leadsLast30Days"
            icon="ni ni-single-02"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                <i class="fas fa-plus"></i>
                {{leadsToday}}
              </span>
              <span class="text-nowrap">Leads Today</span>
            </template>
          </stats-card>
        </div>

        <div class="col-xl-6 col-md-6">
          <stats-card
            title="Applications Last 30 Days"
            type="gradient-green"
            :sub-title="applicationsLast30Days"
            icon="ni ni-single-copy-04"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                <i class="fa fa-plus"></i>
                {{applicationsToday}}
              </span>
              <span class="text-nowrap">Applications Today</span>
            </template>
          </stats-card>
        </div>

        <div class="col-xl-6 col-md-6" v-if="this.$user.partner_id == null">
          <stats-card
            title="Pos Applications Last 30 Days"
            type="gradient-green"
            :sub-title="posApplicationsLast30Days"
            icon="ni ni-credit-card"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                <i class="fa fa-plus"></i>
                {{posApplicationsToday}}
              </span>
              <span class="text-nowrap">Pos Applications Today</span>
            </template>
          </stats-card>
        </div>

        <!-- <div class="col-xl-6 col-md-6">
          <stats-card
            title="Applications"
            type="gradient-green"
            sub-title="924"
            icon="ni ni-money-coins"
          >
            <template slot="footer">
              <span class="text-danger mr-2">
                <i class="fa fa-arrow-down"></i> 5.72%
              </span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>

        <div class="col-xl-6 col-md-6">
          <stats-card
            title="Performance"
            type="gradient-info"
            sub-title="49,65%"
            icon="ni ni-chart-bar-32"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                <i class="fa fa-arrow-up"></i> 54.8%
              </span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>-->
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <card type="default" header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-light text-uppercase ls-1 mb-1">Overview</h6>
                <h5 class="h3 text-white mb-0">Leads</h5>
              </div>
              <div class="col">
                <ul class="nav nav-pills justify-content-end">
                  <li class="nav-item mr-2 mr-md-0">
                    <a class="nav-link py-2 px-3 active" href="#">
                      <span class="d-none d-md-block">Month</span>
                      <span class="d-md-none">M</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <line-chart
              :height="250"
              ref="leadsChart"
              :chart-data="leadsChart.chartData"
              :extra-options="leadsChart.extraOptions"
            ></line-chart>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <card type="default" header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-light text-uppercase ls-1 mb-1">Overview</h6>
                <h5 class="h3 text-white mb-0">Applications New / Updates</h5>
              </div>
              <div class="col">
                <ul class="nav nav-pills justify-content-end">
                  <li class="nav-item mr-2 mr-md-0">
                    <a class="nav-link py-2 px-3 active" href="#">
                      <span class="d-none d-md-block">Month</span>
                      <span class="d-md-none">M</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <line-chart
              :height="250"
              ref="applicationsChart"
              :chart-data="applicationsChart.chartData"
              :extra-options="applicationsChart.extraOptions"
            ></line-chart>
          </card>
        </div>

        <!-- <div class="col-xl-4">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                <h5 class="h3 mb-0">Applications</h5>
              </div>
            </div>

            <bar-chart :height="350" ref="barChart" :chart-data="redBarChart.chartData"></bar-chart>
          </card>
        </div>-->
      </div>

      <div class="row" v-if="this.$user.partner_id == null">
        <div class="col-xl-12">
          <card type="default" header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-light text-uppercase ls-1 mb-1">Overview</h6>
                <h5 class="h3 text-white mb-0">New Pos Applications</h5>
              </div>
              <div class="col">
                <ul class="nav nav-pills justify-content-end">
                  <li class="nav-item mr-2 mr-md-0">
                    <a class="nav-link py-2 px-3 active" href="#">
                      <span class="d-none d-md-block">Month</span>
                      <span class="d-md-none">M</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <line-chart
              :height="250"
              ref="posApplicationsChart"
              :chart-data="posApplicationsChart.chartData"
              :extra-options="posApplicationsChart.extraOptions"
            ></line-chart>
          </card>
        </div>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";

// Lists
import ActivityFeed from "./ActivityFeed";
import TaskList from "./TaskList";
import UserList from "./UserList";
import ProgressTrackList from "./ProgressTrackList";

// Tables
import LightTable from "./LightTable";
import SocialTrafficTable from "./SocialTrafficTable";
import PageVisitsTable from "./PageVisitsTable";

import { resourceFactory } from "../../resourceFactory";

const dashboardResource = resourceFactory.get("dashboardResource");

export default {
  components: {
    ActivityFeed,
    LineChart,
    BarChart,
    BaseProgress,
    RouteBreadCrumb
  },
  data() {
    return {
      leadsChart: {
        extraOptions: chartConfigs.blueChartOptions
      },
      applicationsChart: {
        extraOptions: chartConfigs.blueChartOptions
      },
      posApplicationsChart: {
        extraOptions: chartConfigs.blueChartOptions
      },
      redBarChart: {
        chartData: {
          labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [
            {
              label: "Applications",
              data: [25, 20, 30, 22, 17, 29]
            }
          ]
        },
        extraOptions: chartConfigs.blueChartOptions
      },
      leadsToday: "0",
      leadsLast30Days: "0",
      applicationsToday: "0",
      applicationsLast30Days: "0",
      posApplicationsToday: "0",
      posApplicationsLast30Days: "0",

      leadsChartData: [],
      leadsChartLabels: [],

      applicationsChartData: [],
      applicationsChartLabels: [],

      posApplicationsChartData: [],
      posApplicationsChartLabels: []
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      dashboardResource
        .overview()
        .then(response => {
          this.leadsToday = response.data.leadsToday;
          this.leadsLast30Days = response.data.leadsLast30Days;
          this.applicationsToday = response.data.applicationsToday;
          this.applicationsLast30Days = response.data.applicationsLast30Days;
          this.posApplicationsToday = response.data.posApplicationsToday;
          this.posApplicationsLast30Days = response.data.posApplicationsLast30Days;

          this.leadsChartData = response.data.leadsLast30DaysChart;
          this.leadsChartLabels = response.data.last30Days;

          this.applicationsChartData =
            response.data.applicationsLast30DaysChart;
          this.applicationsUpdatedChartData =
            response.data.applicationsUpdatedLast30DaysChart;
          this.applicationsChartLabels = response.data.last30Days;

          this.posApplicationsChartData = response.data.posApplicationsLast30DaysChart;
          this.posApplicationsChartLabels = response.data.last30Days;

          this.initLeadsChart();
          this.initApplicationsChart();
          this.initPosApplicationsChart();
        })
        .catch(error => {
          console.log(error);
        });
    },
    initLeadsChart() {
      let chartData = {
        datasets: [
          {
            label: "Leads",
            data: this.leadsChartData
          }
        ],
        labels: this.leadsChartLabels
      };
      this.leadsChart.chartData = chartData;
    },
    initApplicationsChart() {
      let chartData = {
        datasets: [
          {
            label: "New",
            data: this.applicationsChartData
          },
          {
            label: "Updated",
            data: this.applicationsUpdatedChartData,
            borderColor: "#bae755",
            pointBackgroundColor: "#bae755"
          }
        ],
        labels: this.applicationsChartLabels
      };
      this.applicationsChart.chartData = chartData;
    },
    initPosApplicationsChart() {
        let chartData = {
          datasets: [
            {
              label: "New",
              data: this.posApplicationsChartData
            }
          ],
          labels: this.posApplicationsChartLabels
        };
        this.posApplicationsChart.chartData = chartData;
      }
    }
};
</script>
<style></style>
